<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M-3.35,790.75h0.17c0.94,1.05,2.28,1.65,3.68,1.65s2.74-0.6,3.68-1.65h1.27v1.2c0.49,0.27,1.02,0.58,1.65,1
	c1.1,4.4,2.2,6.37,2.2,8.25c-1.5,0.6-3.1,1.02-4.72,1.3L2,800.45c-1.54,0.1-4.66-0.22-6.83-0.78l-0.64,2.43
	c-0.97-0.25-1.92-0.53-2.84-0.89c0-1.92,1.1-3.85,2.2-8.25c0.63-0.42,1.16-0.73,1.65-1v-1.2H-3.35z M1.6,796.27l2.2,2.2l2.2-2.2
	l-2.2-2.2L1.6,796.27z M4.35,786.35c0-2.13-1.72-3.85-3.85-3.85l0,0c-2.13,0-3.85,1.72-3.85,3.85l0,0c0,2.13,1.72,3.85,3.85,3.85
	l0,0C2.63,790.2,4.35,788.48,4.35,786.35L4.35,786.35z"/>
</svg>

</template>